import React, { useRef, useState } from "react";
import css from "./index.module.scss";
import TriangleDownSvg from "/public/images/icons/triangleDown.svg";

export default function AccordionRow({
  row,
  className = "",
}) {
  let contentRef = useRef();
  let innerContentRef = useRef();
  const [open, setOpen] = useState("");

  function handleClick(){
    let maxHeight = innerContentRef.current.getBoundingClientRect().height;

    if (contentRef.current.getAttribute("style")){
      contentRef.current.setAttribute("style", "");
      setOpen("");
    } else {
      contentRef.current.setAttribute("style", `max-height:${maxHeight}px`);
      setOpen(css.open);
    }
  };

  let classNameInner = `${css.row} ${open} ${className}`;

  return (
    <div className={classNameInner} onClick={handleClick}>
      <div className={css.header}>
        <div className={css.column}>
          <span>{row.header}</span>
          {row.subheader && <span className={css.subheader}>{row.subheader}</span>}
        </div>
        <button >
          <TriangleDownSvg/>
        </button>
      </div>
      <div className={css.content} ref={contentRef}>
        <div className={css.contentInner} ref={innerContentRef}>
          {row.content}
        </div>
      </div>

    </div>
  );
}
